// extracted by mini-css-extract-plugin
module.exports = {"labelInfo":"Label_labelInfo__sY0B_","pointer":"Label_pointer__ipUcx","fileLabel":"Label_fileLabel__OE936"};